import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { Modal } from "components";
import { updateGrnLine } from "actions/grns";

const InputField = (props) => <Input {...props} />;

const SupplierBatchNumberModal = ({
  grnLineId,
  handleClose,
  handleSubmit,
  invalid,
  pristine,
  updateGrnLine,
}) => {
  const onSubmit = async ({ supplier_batch_number }) => {
    await updateGrnLine(grnLineId, {
      supplier_batch_number: supplier_batch_number.trim(),
    });
    handleClose();
  };

  return (
    <Modal
      handleClose={handleClose}
      size="md"
      header={{ title: "Numer partii" }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <Button
            disabled={invalid || pristine}
            type="save"
            text="Zapisz"
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Field
          label="Numer partii"
          name="supplier_batch_number"
          component={InputField}
        />
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.supplier_batch_number?.trim()) {
    errors.supplier_batch_number = "Pole wymagane!";
  }
  return errors;
};

export default reduxForm({
  form: "supplier-batch-number-form",
  validate,
  enableReinitialize: true,
})(
  connect(null, (dispatch) => ({
    updateGrnLine: (id, values) => dispatch(updateGrnLine(id, values)),
  }))(SupplierBatchNumberModal),
);
